<div class="block-status">
  <mat-card>
    <ng-container *ngIf="block$ | async as block">
      <div class="content">
        This Sender is currently blocked.
        <div class="inner"><b>Blocked message: &nbsp;</b>{{ block.message }}</div>
      </div>

      <mat-card-actions align="end">
        <button mat-raised-button color="primary" (click)="unblockSender()">Unblock sender</button>
      </mat-card-actions>
    </ng-container>

    <ng-container *ngIf="(block$ | async) === null">
      <div class="content">
        This sender is not currently blocked.
        <div class="inner">
          <b>Would you like to block this sender?</b>
          <mat-form-field>
            <textarea
              matInput
              [(ngModel)]="inputtedBlockMessage"
              placeholder="Add reasoning for blocking this sender please"
              matTextareaAutosize="true"
              matAutosizeMinRow="5"
              matAutosizeMaxRows="10"
              maxlength="500"
            ></textarea>
          </mat-form-field>
        </div>
      </div>
      <mat-card-actions align="end">
        <button mat-raised-button color="primary" (click)="blockSender()">Block sender</button>
      </mat-card-actions>
    </ng-container>
  </mat-card>
</div>
